import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiEndpoints } from '../constants/api-endpoints';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  constructor(
    private _http: HttpService
  ) { }

  public user(): Observable<any> {
    return this._http.rget(ApiEndpoints.USER);
  }

  public findUserByContact(contactId: string): Observable<any> {
    return this._http.rget(ApiEndpoints.USER_FIND_BY_CONTACT + '?contactId=' + contactId);
  }

  public login(data: any): Observable<any> {
    return this._http.rpost(ApiEndpoints.LOGIN, data);
  }

  public register(data: any): Observable<any> {
    return this._http.rpost(ApiEndpoints.REGISTER, data);
  }

  public forgotPassword(data: any): Observable<any> {
    return this._http.rpost(ApiEndpoints.FORGOT_PASSWORD, data);
  }

  public resetPassword(data: any): Observable<any> {
    return this._http.rpost(ApiEndpoints.RESET_PASSWORD, data);
  }

  public fileUpload(data: any): Observable<any> {
    return this._http.rpost(ApiEndpoints.FILE_UPLOAD, data);
  }

  public contactsGet(): Observable<any> {
    return this._http.rget(ApiEndpoints.CONTACTS_GET);
  }

  public contactsSearch(q: any): Observable<any> {
    return this._http.rget(ApiEndpoints.CONTACT_SEARCH + '?q=' + q);
  }

  public contactAdd(data: any): Observable<any> {
    return this._http.rpost(ApiEndpoints.CONTACT_ADD, data);
  }

  public contactUpdate(contactId: string, data: any): Observable<any> {
    return this._http.rput(ApiEndpoints.CONTACT_UPDATE.replace(":id", contactId), data);
  }

  public contactBlock(contactId: string): Observable<any> {
    return this._http.rpost(ApiEndpoints.CONTACT_BLOCK.replace(":id", contactId), []);
  }

  public contactDelete(contactId: string): Observable<any> {
    return this._http.rdelete(ApiEndpoints.CONTACT_DELETE.replace(":id", contactId));
  }

  public contactsSync(data: any): Observable<any> {
    return this._http.rpost(ApiEndpoints.CONTACTS_SYNC, data);
  }

  public contactsInvite(data: any): Observable<any> {
    return this._http.rpost(ApiEndpoints.CONTACTS_INVITE, data);
  }

  public statsCurrencies(): Observable<any> {
    return this._http.rget(ApiEndpoints.STATS_CURRENCIES);
  }

  public statsWeather(lat: any, long: any): Observable<any> {
    return this._http.rget(ApiEndpoints.STATS_WEATHER + '?lat=' + lat + '&long=' + long);
  }

  public statsTime(query: string): Observable<any> {
    return this._http.rget(ApiEndpoints.STATS_TIME + '?q=' + query);
  }

  public statsLeagues(): Observable<any> {
    return this._http.rget(ApiEndpoints.STATS_LEAGUES);
  }

  public statsNews(): Observable<any> {
    return this._http.rget(ApiEndpoints.STATS_NEWS);
  }

  public callLogs(): Observable<any> {
    return this._http.rget(ApiEndpoints.VOICE_CALL_HISTORY);
  }

  public newsletter(data: any): Observable<any> {
    return this._http.rpost(ApiEndpoints.NEWSLETTER, data);
  }

  public contactus(data: any): Observable<any> {
    return this._http.rpost(ApiEndpoints.CONTACT_US, data);
  }

  public chatGet(userId: string): Observable<any> {
    return this._http.rget(ApiEndpoints.CHAT + '?userId=' + userId);
  }

  public chatStore(data: any): Observable<any> {
    return this._http.rpost(ApiEndpoints.CHAT, data);
  }

  public chatRecent(): Observable<any> {
    return this._http.rget(ApiEndpoints.CHAT_RECENT);
  }

  public userProfileUpdate(data: any): Observable<any> {
    return this._http.rput(ApiEndpoints.USER_UPDATE_PROFILE, data);
  }

  public countries(): Observable<any> {
    return this._http.rget(ApiEndpoints.COUNTRIES);
  }

  public states(countryCode: any): Observable<any> {
    return this._http.rget(ApiEndpoints.STATES.replace(":countrycode", countryCode));
  }

  public cities(countryCode: any, stateCode: any): Observable<any> {
    let url = ApiEndpoints.CITIES.replace(":countrycode", countryCode);
    url = url.replace(":statecode", stateCode);
    return this._http.rget(url);
  }

  public notificationsGet(): Observable<any> {
    return this._http.rget(ApiEndpoints.NOTIFICATIONS);
  }

  public notificationsDelete(): Observable<any> {
    return this._http.rdelete(ApiEndpoints.NOTIFICATIONS);
  }
}
